import { Sparkles } from 'lucide-react';
import { cn } from '@/lib/utils';

/**
 * The Ask Cannafax mark — the iconic amber circle. One definition, used by
 * every surface (header utilities, inline pills) so the mark is identical
 * wherever it appears.
 *
 * Sizes are whole even pixels, not rem utilities: the app's 17px root made
 * `h-9` / `h-6` render as 38.25px / 25.5px circles whose opposite edges
 * antialiased differently, so the circle looked faintly squashed. The fill
 * and the symmetric glow come from `.ai-mark` in index.css (AI gradient
 * tokens) — never add `bg-gradient-*` or `shadow-*` utilities on top.
 */
export const AI_MARK_SIZES = {
  /** Header utilities (phones, tablets, desktop). */
  md: { box: 'h-[38px] w-[38px]', icon: 'h-[16px] w-[16px]' },
  /** Inline "Ask Cannafax" pills next to a label. */
  sm: { box: 'h-[26px] w-[26px]', icon: 'h-[14px] w-[14px]' },
} as const;

export type AskCannafaxMarkSize = keyof typeof AI_MARK_SIZES;

export default function AskCannafaxMark({
  size = 'md',
  className,
}: {
  size?: AskCannafaxMarkSize;
  className?: string;
}) {
  const s = AI_MARK_SIZES[size];
  return (
    <span className={cn('ai-mark rounded-full', s.box, className)} aria-hidden>
      <Sparkles className={s.icon} />
    </span>
  );
}
